import React, { useState } from "react";
import LeftMenuSidebar from "../../../unicomponents/LeftMenuSidebar";
import ApSubjectManagement from "./components/ApSubjectManagement";
import RetakeSeniorManagement from "./components/RetakeSeniorManagement";
import TransferStudent from "./components/TransferStudent";

export default function ExtraLessonManagement() {
  const [activeMenu, setActiveMenu] = useState({
    menu_name: "ap_subject",
    menu_id: "ap_subject",
  });

  const menuData = [
    {
      item_name: "ap_subject",
      item_label: "AP과목",
    },
    {
      item_name: "retake_senior",
      item_label: "Retake/Senior",
    },
    {
      item_name: "transfer_student",
      item_label: "전학생 입력",
    },
  ];

  const renderContent = () => {
    switch (activeMenu.menu_name) {
      case "ap_subject":
        return <ApSubjectManagement />;
      case "retake_senior":
        return <RetakeSeniorManagement />;
      case "transfer_student":
        return <TransferStudent />;
      default:
        return <ApSubjectManagement />;
    }
  };

  return (
    <div className="basicWidth">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-md-2">
            <LeftMenuSidebar
              activeMenu={activeMenu}
              setActiveMenu={setActiveMenu}
              menuData={menuData}
              itemName="item_name"
              itemLabel="item_label"
            />
          </div>
          <div className="col-12 col-md-10">{renderContent()}</div>
        </div>
      </div>
    </div>
  );
}
